import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

const timeWindowOptions = [
    {
        name: 'All Time',
        amount: null,
        unit: 'year',
    },
    {
        name: '10 Years',
        amount: 10,
        unit: 'year',
    }
]

const filterTimeData = (data, timeDiffObject, timeDataField = 'SampleDate') => {
    if (timeDiffObject.amount) {
        const edgeDate = dayjs().subtract(
            timeDiffObject.amount,
            timeDiffObject.unit
        )
        const newData = data.filter(d => {
            const date = d[timeDataField]
            return dayjs(date).diff(edgeDate) >= 0
        })
        return newData
    } else {
        return data
    }
}

const filterMultiSeriesTimeData = (data, timeDiffObject, timeDataField = 'SampleDate') => {
    return data.map(d => ({
        ...d,
        Data: filterTimeData(d.Data, timeDiffObject, timeDataField)
    }))
}

const filterMultiSeriesTimePeriod = (data, dateParams, timeDataField = 'SampleDate') => {
    return data.map(d => ({
        ...d,
        Data: getDataWithinTimePeriod(d.Data, dateParams, timeDataField)
    }))
}

const getDataWithinTimePeriod = (data, dateParams, timeDataField = 'SampleDate') => {
    return data.filter(x => {
        if (dateParams[0] && dateParams[1]) {
            return dayjs(x[timeDataField]).isBetween(dateParams[0], dateParams[1], null, '[]')
        } else if (dateParams[0]) {
            return dayjs(x[timeDataField]).isSameOrAfter(dateParams[0])
        } else if (dateParams[1]) {
            return dayjs(x[timeDataField]).isSameOrBefore(dateParams[1])
        } else {
            return false
        }
    })
}

export { timeWindowOptions, filterTimeData, getDataWithinTimePeriod, filterMultiSeriesTimeData, filterMultiSeriesTimePeriod }
export default filterTimeData
